import { Route, Routes } from "react-router-dom";
import { Routes as SalesRoutes } from "./routes";
import { SalesRouterCmp } from "./types";
import InquirySearchPage from "../pages/inquiries/InquirySearchPage/InquirySearchPage";
import InquiryDetailPage from "../pages/inquiries/InquiryDetailPage/InquiryDetailPage";
import ListingSearchPage from "../pages/listings/ListingSearchPage/ListingSearchPage";
import ListingDetailPage from "../pages/listings/ListingDetailPage/ListingDetailPage";

const SalesRouter: SalesRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={InquirySearchPage.route} element={<InquirySearchPage />} />
        <Route path={InquiryDetailPage.route} element={<InquiryDetailPage />} />
        <Route path={ListingSearchPage.route} element={<ListingSearchPage />} />
        <Route path={ListingDetailPage.route} element={<ListingDetailPage />} />
      </Routes>
    </>
  );
};

SalesRouter.route = SalesRoutes.SalesRouter;

export default SalesRouter;
